import { Reducer } from 'redux';

import { IPoliticalGroupSpecific, IPoliticalGroupSpecificSimple, IProgramEditor, IProgramType, ISearchActionTypes, ISearchState, ITimeFilters } from './Types';

let initialState: ISearchState = {
    programTypes: [],
    allProgramTypesID: [],
    allProgramTypesSTR: [],
    programEditors: [],
    allProgramEditorsID: null,
    allProgramEditorsSTR: [],
    politicalGroup: [],
    allPoliticalGroupID: [],
    allPoliticalGroupSTR: [],
    autocompletePersonList: [],
    mediasSource: null,
    isLoading: false,
    isPersonAutocompleteLoading: false,
    searchFilters: null,
    timeFilters: null,
    elections: [],
    allElectionsID: [],
    allElectionsSTR: [],
};

const reducer: Reducer<ISearchState> = (state = initialState, action) => {
    switch (action.type) {
        case ISearchActionTypes.GET_PROGRAM_TYPES: {
            return {
                ...state,
                isLoading: true
            };
        }
        case ISearchActionTypes.GET_PROGRAM_TYPES_SUCCESS: {
            let programs = action.payload
            let programsID:number[] = programs.map((x:IProgramType)=>{
                return x.id
            })
            let programsStr:string[] = programs.map((x:IProgramType)=>{
                return x.name
            })
            return{
                ...state,
                programTypes: action.payload,
                allProgramTypesID: programsID,
                allProgramTypesSTR: programsStr,
                isLoading: false
            }
        }
        
        case ISearchActionTypes.GET_ELECTION_CAMPAIGN: {
            let elections = [
                {id: 0, name: "Régionales 2021 (1er tour)"}, 
                {id: 1, name: "Régionales 2021 (2ème tour)"},
                {id: 2, name: "Départementales 2021 (1er tour)"},
                {id: 3, name: "Départementales 2021 (2ème tour)"},
            ]
            let electionsID:number[] = [0, 1, 2, 3]
            let electionsStr:string[] = ["Régionales 2021 (1er tour)", "Régionales 2021 (2ème tour)", "Départementales 2021 (1er tour)", "Départementales 2021 (2ème tour)"]
            return{
                ...state,
                elections,
                allElectionsID: electionsID,
                allElectionsSTR: electionsStr,
            }
        }
        case ISearchActionTypes.GET_PROGRAM_EDITORS: {
            return {
                ...state,
                isLoading: true
            };
        }
        case ISearchActionTypes.GET_PROGRAM_EDITORS_SUCCESS: {
            let programs = action.payload
            let programsID:number[] = programs.map((x:IProgramEditor)=>{
                return x.id
            })
            let programsStr:string[] = programs.map((x:IProgramEditor)=>{
                return x.name
            })
            return{
                ...state,
                programEditors: action.payload,
                allProgramEditorsID: programsID,
                allProgramEditorsSTR: programsStr,
                isLoading: false
            }
        }
        case ISearchActionTypes.GET_AUTOCOMPLETE_PERSON: {
            return {
                ...state,
                isPersonAutocompleteLoading: true,
                autocompletePersonList: []
            }
        }
        case ISearchActionTypes.GET_AUTOCOMPLETE_PERSON_SUCCESS: {
            return {
                ...state,
                autocompletePersonList: action.payload,
                isPersonAutocompleteLoading: false,
            }
        }
        case ISearchActionTypes.CLEAR_PERSONS_LIST: {
            return {
                ...state,
                isPersonAutocompleteLoading: false,
                autocompletePersonList: []
            }
        }
        case ISearchActionTypes.GET_MEDIAS_SOURCE: {
            return {
                ...state,
                isLoading: true
            }
        }
        case ISearchActionTypes.GET_MEDIAS_SOURCE_SUCCESS: {
            return {
                ...state,
                mediasSource: action.payload,
                isLoading: false
            }
        }
        case ISearchActionTypes.GET_POLITICAL_GROUP_SPECIFIC: {
            return {
                ...state,
                isLoading: true
            };
        }
        case ISearchActionTypes.GET_POLITICAL_GROUP_SPECIFIC_SUCCESS: {
            let groups = action.payload
            let groupsID:number[] = groups.map((x:IPoliticalGroupSpecific)=>{
                return x.political_group_id
            })
            let groupsStr:string[] = groups.map((x:IPoliticalGroupSpecific)=>{
                return x.political_group_name
            })
            let formattedGroups:IPoliticalGroupSpecificSimple[] = groups.map((x:IPoliticalGroupSpecific)=>{
                return {
                    id: x.political_group_id,
                    name: x.political_group_name,
                    color: x.political_group_color
                }
            })
            return{
                ...state,
                politicalGroup: formattedGroups,
                allPoliticalGroupID: groupsID,
                allPoliticalGroupSTR: groupsStr,
                isLoading: false
            }
        }
        case ISearchActionTypes.SAVE_FILTERS: {
            return {
                ...state,
                searchFilters: action.payload,
            }
        }
        case ISearchActionTypes.RESET_FILTERS: {
            return {
                ...state,
                searchFilters: null,
                timeFilters: null
            }
        }
        case ISearchActionTypes.SAVE_TIME_SELECTION: {
            let filters: ITimeFilters = action.payload
            return {
                ...state,
                timeFilters: filters,
                searchFilters: {
                    ...state.searchFilters,
                    start_date: filters.startDate,
                    end_date: filters.endDate,
                    program_types_ids: [],
                    program_types_str: null,
                    media_ids: [],
                    media_str: null,
                },
            }
        }
        case ISearchActionTypes.RESET_DATA: {
            let newState = {...state}
            newState = initialState
            return newState
        }
        default: {
            return state;
        }
    }
};

export { reducer as SearchReducer };
